export default __webpack_public_path__ + "img/favicon.23fb0e.ico";